import { TrendingUp, ShoppingBag, MessageCircle } from "lucide-react";

const STATS = [
  {
    icon: TrendingUp,
    figure: "3.4×",
    label: "Avg. foot-traffic lift",
    sub: "during the 2 weeks following a Visit + Shoot campaign",
  },
  {
    icon: ShoppingBag,
    figure: "+38%",
    label: "Direct revenue uplift",
    sub: "across F&B and beauty venues in our last 24 campaigns",
  },
  {
    icon: MessageCircle,
    figure: "12K",
    label: "Avg. organic reach",
    sub: "per creator visit — stories, reels, and tagged location posts",
  },
];

export default function Stats() {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="py-20 sm:py-28 bg-[#F6F5F1]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.22em] text-[#276152] font-semibold">
            Built for local brands
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl mt-5 tracking-[-0.03em] text-[#0D3A35] font-semibold leading-[0.95]">
            Real venues. Real visits.
            <br />
            <span className="text-[#276152]">Real revenue.</span>
          </h2>
          <p className="mt-7 text-lg text-[#0D3A35]/70 max-w-xl leading-relaxed">
            We don&apos;t deliver vanity views. Lychee partners with hotels,
            restaurants, clinics and retail stores to drive the only number
            that matters &mdash; customers walking through your door.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                data-testid={`stat-card-${i}`}
                className="bg-white border border-[#B1B7AB]/40 rounded-2xl p-8 flex flex-col gap-6 min-h-[230px] transition-transform hover:-translate-y-1 duration-300"
              >
                <div className="flex items-center justify-between">
                  <Icon className="w-5 h-5 text-[#276152]" strokeWidth={1.6} />
                  <span className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[#0D3A35]/55">
                    0{i + 1}
                  </span>
                </div>
                <div>
                  <div className="font-display text-6xl sm:text-7xl text-[#0D3A35] leading-none tracking-[-0.04em]">
                    {s.figure}
                  </div>
                  <p className="mt-4 font-semibold text-[#0D3A35] text-base">
                    {s.label}
                  </p>
                  <p className="mt-1 text-sm text-[#0D3A35]/60 leading-relaxed">
                    {s.sub}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
